import React from 'react';

function ContactUs (){
    return(
        <div style={{margin:"100px auto",width: "80%", display:"grid", gridTemplateColumns:"50%",gridTemplateRows:"200px 200px"}}>
            <div><h1>Swar M. Patel </h1><p>CE-96</p><a href="mailto:smp1613@gmail.com " target="_top" >smp1613@gmail.com </a></div>
            <div><h1>Priyank Kumar Chaudhari</h1><p>CE-104</p><a href="mailto:priyank810123@gmail.com" target="_top" >priyank810123@gmail.com</a></div>                        
        </div>
    )
}
export default ContactUs;